import { createApp } from 'vue'

import 'vuetify/styles' // should be at the top

import Notifications from '@kyvg/vue3-notification'

import '@kidzonet/chunk-loading-error-listener'
import initializeControlAPIAuth from '@kidzonet/control-api-auth'
import App from '@kidzonet/control-app-root'
import { createPiniaWithSentryMiddleware } from '@kidzonet/pinia'
import SentryInit from '@kidzonet/vue3-sentry'
// @ts-expect-error strange import problems
import i18n from '@kidzonet/vue-i18n-package/obj.d.ts'

import router from './router'
import VuetifyPlugin from './vuetify'

initializeControlAPIAuth()

const pinia = createPiniaWithSentryMiddleware()

const app = createApp(App)

app.use(pinia as any)
app.use(Notifications)
app.use(VuetifyPlugin)

app.use(router)
app.use(i18n)

app.mount('#app')

SentryInit(app, 'control', router)
